export default __webpack_public_path__ + "static/media/main_bg.b4926db4.mp4";